import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, filter, Observable, Subject, takeUntil } from 'rxjs';
import { DraftListTableColumn } from '../../../initiate-and-release/Models/Drafts/DraftResponse';
import { deleteInitiatedDraft } from '../../../initiate-and-release/actions/init-release.actions';
import { selectCanRelease } from '../../../create-request/reducers';
import { Router } from '@angular/router';
import { navRouteConstants } from '../../utilities/Constants';
import { initializePage } from '../../actions/shared.actions';
import { selectInitReleaseTransactionDeleteCallCompleted, selectInitReleaseTransactionDeleteCallSuccessful } from '../../../initiate-and-release/reducers';
import { InitReleaseActions } from '../../../initiate-and-release/actions';
import { ToastrService } from 'ngx-toastr';
import { ReviewPageActions } from '../../../create-request/actions';
import { selectIsFsaUser } from '../../../account-info-header/reducers';

@Component({
  standalone: false,
  selector: 'mm-delete-initiated-draft-modal',
  templateUrl: './delete-initiated-draft-modal.component.html',
  styleUrls: ['./delete-initiated-draft-modal.component.scss'],
})
export class DeleteInitiatedDraftModalComponent {
  @Input() showModal$: Observable<boolean>;
  @Input() currentDraft: DraftListTableColumn | null;
  @Input() isSloa: boolean;
  @Input() isFromReviewPage: boolean;
  destroy$: Subject<boolean> = new Subject<boolean>();
  modal: EverestModal;
  isFsaUser: boolean = false;
  textBodyTxn: string = 'Are you sure you want to cancel this transaction? This action cannot be undone.';
  textBodySloa: string = 'Are you sure you want to delete this standing authorization? This action cannot be undone.';
  titleTxn: string = 'Cancel this transaction?';
  titleSloa: string = 'Delete this standing authorization?';

  constructor(private store: Store, private router: Router, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.showModal$.pipe(takeUntil(this.destroy$)).subscribe((show) => {
      this.modal = document.getElementById('delete-draft-modal') as EverestModal;
      if (show) this.modal.showModal();
    });

    this.store.select(selectIsFsaUser).pipe(takeUntil(this.destroy$)).subscribe(isFsa => {
      this.isFsaUser = isFsa ?? false;
    });

    this.store.select(selectInitReleaseTransactionDeleteCallSuccessful).pipe(
      takeUntil(this.destroy$),
      filter((success) => success)
    ).subscribe(_success => {
      if (this.isSloa) {
        this.toastr.success('Standing authorization deleted');
      }
      else {
        this.toastr.success('Transaction cancelled');
      }
      if (!this.isFromReviewPage) {
        this.store.dispatch(InitReleaseActions.getInitReleaseList());
        if (this.isFsaUser) {
          this.store.dispatch(InitReleaseActions.callCreateCustomRulesGet());
        }
      }
    });

    combineLatest([
      this.store.select(selectInitReleaseTransactionDeleteCallCompleted),
      this.store.select(selectCanRelease),
    ])
      .pipe(
        takeUntil(this.destroy$),
        filter(([complete, _canRelease]) => complete)
      ).subscribe(([_complete, canRelease]) => {
        if (canRelease) {
          this.router.navigate([navRouteConstants.initiateAndRelease], { onSameUrlNavigation: 'reload' });
        }
        if (this.isFromReviewPage) {
          this.store.dispatch(ReviewPageActions.clearAttentionMessage());
          this.store.dispatch(ReviewPageActions.editClicked());
          this.store.dispatch(InitReleaseActions.getInitReleaseList());
        }
      })
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  onBackClick() {
    this.modal.hideModal();
  }

  onDeleteTemplateClick() {
    this.store.dispatch(deleteInitiatedDraft({ draftId: this.currentDraft?.DraftId ?? '' }));
    this.modal.hideModal();
  }
}

type EverestModal = HTMLElement & {
  showModal: () => {},
  hideModal: () => {}
};
